import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */

export var getMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var messages, parentLocale, _messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          locale = locale.replace('-', '_');
          _context.prev = 1;
          _context.next = 4;
          return import( /* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */"../i18n/".concat(locale));
        case 4:
          messages = _context.sent;
          return _context.abrupt("return", messages.default);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
        case 10:
          _context.prev = 10;
          parentLocale = locale.split(/[-_]/)[0];
          _context.next = 14;
          return import( /* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */"../i18n/".concat(parentLocale));
        case 14:
          _messages = _context.sent;
          return _context.abrupt("return", _messages.default);
        case 18:
          _context.prev = 18;
          _context.t1 = _context["catch"](10);
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8], [10, 18]]);
  }));
  return function getMessagesForLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();